import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
// Connects to tab targets in order to display associated content targets when the tab is selected
// Content targets must be placed within a container target in order to be displayed -- this allows for selected
// content to be displayed in multiple places on the page
// A specific tab can be preselected on page load by setting `data-tabs-target="selected"` on the tab
// If not specified, the first tab will be selected
export default class extends Controller {
  static targets = ["tab", "content", "container", "selected"];

  connect() {
    this.hideAllTabContent();

    if (this.selectedTargets.length > 0) {
      this.selectTab(this.selectedTargets[0]);
    } else if (this.tabTargets.length > 0) {
      this.selectTab(this.tabTargets[0]);
    }
  }

  changeTab(event) {
    const tab = event.currentTarget;
    this.hideAllTabContent();
    this.unselectTabs();
    this.selectTab(tab);
  }

  hideAllTabContent() {
    this.contentTargets.forEach((div) => {
      div.classList.add("hidden");
    });
  }

  unselectTabs() {
    this.tabTargets.forEach((tab) => {
      tab.classList.remove("bg-forest", "text-white");
      tab.classList.add("bg-white", "text-charcoal");
    });
  }

  selectTab(tab) {
    const selector = tab.getAttribute("data-tabs-selector");

    tab.classList.remove("bg-white", "text-charcoal");
    tab.classList.add("bg-forest", "text-white");

    // Show all selected content within containerTargets
    this.containerTargets.forEach((containerTarget) => {
      if (containerTarget) {
        let contentDiv = containerTarget.querySelector(selector);

        if (contentDiv) {
          contentDiv.classList.remove("hidden");
        }
      }
    });
  }
}
